"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
var Item = function Item(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? '#' : _ref$href,
    isPreview = _ref.isPreview,
    onClick = _ref.onClick,
    type = _ref.type;
  var rootClassName = (0, _classnames["default"])('cds-Gallery-Item', "cds-Gallery-Item--".concat((0, _upperCaseFirst.upperCaseFirst)(type)), {
    'cds-Gallery-Item--Preview': isPreview,
    'swiper-no-swiping': type === 'image360' && !isPreview
  }, className);
  if (!onClick) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: rootClassName
    }, children);
  }
  return /*#__PURE__*/_react["default"].createElement("a", {
    className: rootClassName,
    href: href,
    onClick: onClick
  }, children);
};
exports.Item = Item;